export const WeightChangeGoalsEnum = {
    MILD: 'mild',
    MID: 'mid',
    EXTREME: 'extreme',
};
